import { ANIMATIONS, BORDERS } from '../app.config';
import gsap from '@gsap/business';
import { ScrollTrigger } from '@gsap/business/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class Border {

  constructor(context) {
    this.context = context;
    ANIMATIONS && this.init();
  }

  initAnimations() {
    this.items.forEach(el => {
      switch (el.type) {
        case 'borderLeftRight':
          BORDERS && this.borderAnimation(el.items)
          !BORDERS && document.body.classList.add('borders-off');
          break;
      }
    })
  }

  borderAnimation(items) {
    items.forEach(item => {
      gsap.fromTo(item, {
        'will-change': 'transform',
        width: "0%",
      },
        {
          ease: 'expo.out',
          width: "100%",
          scrollTrigger: {
            trigger: item,
            start: 'top 80%',
            end: 'top 60%',
            scrub: 3
          }
        });
    })
  }


  init() {
    this.items = [{
      type: 'borderLeftRight',
      items: Array.from(this.context.querySelectorAll('[data-animate-border=full]'))
    }]
    this.initAnimations();
  }
}
